// packages/data/src/plugins/persistence/storage/default.ts
import objectStorage from "./object.mjs";
var storage;
try {
  storage = window.localStorage;
  storage.setItem("__wpDataTestLocalStorage", "");
  storage.removeItem("__wpDataTestLocalStorage");
} catch {
  storage = objectStorage;
}
var default_default = storage;
export {
  default_default as default
};
//# sourceMappingURL=default.mjs.map
